import { Outlet } from "react-router-dom";
// The shared header — one component for every role, so a member's nav is
// identical to Admin's and HR's. See layout/Header.js.
import Header from "../Header";

const MemberLayout = () => {
  return (
    <div className="member-layout ">
        <Header />
        <div className="member-body mainOuter">
          <main className="member-content">
            <Outlet />
          </main>

        </div>
    </div>
  );
};

export default MemberLayout;
